<template>
  <div>
    <!-- Search Input -->
    <div class="form-group">
      <input type="text" class="form-control" v-model.trim="term" placeholder="Search product...">
    </div>

    <!-- Results -->
    <img v-if="isSearching" src="static/img/loading.gif" height="32"/>
    <label v-if="productOffers && !isSearching">Found {{productOffers.length}} product offers</label>
    <table class="table table-condensed" v-if="productOffers.length > 0">
      <thead>
        <tr>
          <th class="text-center"><i class="fa fa-flag"></i></th>
          <th>Product</th>
          <th>Codename</th>
          <th>Sale Option</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="productOffer in productOffers">
          <td class="text-center">
            <product-offer-icon v-bind:icon="productOffer.icon" height="36px"></product-offer-icon>
          </td>
          <td>
            <product-offer-item v-bind:productOffer="productOffer"/>
          </td>
          <td>
            {{productOffer.codename}}
          </td>
          <td>
            <sale-option-select v-bind:productOffer="productOffer" v-on:selected-sale-option="updateSelectedSaleOption"/>
          </td>
          <td>
            <button v-if="!isActivePurchased(productOffer) && !isProcessing(productOffer)" class="btn btn-primary" @click="purchase(productOffer)"><i class="fa fa-plus"></i> Add</button>
            <span v-if="isActivePurchased(productOffer)" class="text-success">Purchased</span>
            <img v-if="isProcessing(productOffer)" src="static/img/loading.gif" height="32"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import productOffers from 'services/productOffers'
import ProductOfferIcon from 'components/ProductOfferIcon'
import ProductOfferItem from 'components/ProductOfferItem'
import SaleOptionSelect from 'components/devices/SaleOptionSelect'
import {EventBus} from 'services/eventBus'

export default {
  name: 'search-products',
  props: ['device'],
  data () {
    return {
      productOffers: false,
      activePurchased: [],
      processing: [],
      isSearching: false,
      selectedSaleOption: {},
      term: ''
    }
  },
  created () {
    EventBus.$on('load-usage-rights', usageRights => {
      this.setActivePurchased(usageRights)
    })

    EventBus.$emit('get-usage-rights', this.setActivePurchased)
  },
  methods: {
    search () {
      this.productOffers = false

      if (this.previousRequest) {
        this.previousRequest.abort()
        this.isSearching = false
      }

      if (this.term.length < 3) {
        return
      }

      productOffers.search(this, this.device.uid, this.term).then(
        response => {
          this.productOffers = this.filterSearch(response.body.data)
          this.isSearching = false
        },
        error => {
          console.log(error)
        }
      )
      this.isSearching = true
    },
    purchase (productOffer) {
      var saleOptionID = this.selectedSaleOption[productOffer.id]
      this.addProcessing(productOffer)

      productOffers.purchase(this, this.device.identifier, saleOptionID).then(
        response => {
          EventBus.$emit('update-usage-rights')
          this.removeProcessed(productOffer)
        }
      )
    },
    setActivePurchased (usageRights) {
      var activePurchased = []
      for (var i = 0; i < usageRights.length; i++) {
        var usageRight = usageRights[i]
        if ((usageRight.end_date == null || usageRight.end_date != null) && usageRight.enabled) {
          activePurchased.push(usageRight.product_offer.id)
        }
      }
      this.activePurchased = activePurchased
    },
    isProcessing (productOffer) {
      return this.processing.includes(productOffer.id)
    },
    isActivePurchased (productOffer) {
      return this.activePurchased.includes(productOffer.id)
    },
    filterSearch (productOffers) {
      var filtered = productOffers.filter(p => {
        return p.sale_options !== undefined && p.sale_options.length > 0
      })

      return filtered
    },
    updateSelectedSaleOption (event) {
      this.selectedSaleOption[event.productOfferID] = event.saleOptionID
    },
    addProcessing (productOffer) {
      this.processing.push(productOffer.id)
    },
    removeProcessed (productOffer) {
      var index = this.processing.lastIndexOf(productOffer.id)
      this.processing.splice(index, 1)
      this.activePurchased.push(productOffer.id)
    }
  },
  watch: {
    'term': 'search'
  },
  components: {
    ProductOfferIcon,
    ProductOfferItem,
    SaleOptionSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/SearchProducts.vue